import { createWeb3Modal } from "@web3modal/wagmi/react";

import { flare } from "viem/chains";
import { http, createConfig } from 'wagmi'
import { walletConnect, injected, coinbaseWallet } from 'wagmi/connectors'
//  Get projectId
const projectId = "3828bedc82f5ba0e923c413da3250b1a";

// Create wagmiConfig
const metadata = {
  name: "Flare Reborn",
  description: "Flare Reborn",
  // url for the project: this is required
  url: "https://flare-reborn.xyz",
};

export const chains = [
  {
    id: 14,
    name: "Flare Mainnet",
    network: "Flare",
    nativeCurrency: {
      decimals: 18,
      name: "FLR",
      symbol: "FLR",
    },
    rpcUrls: {
      default: {
        http: ["https://flare-api.flare.network/ext/C/rpc"],
      },
      public: {
        http: ["https://flare-api.flare.network/ext/C/rpc"],
      },
    },
    blockExplorers: {
      default: {
        name: "Blockscout",
        url: "https://flare-explorer.flare.network/",
      },
    },
  },
];

export const wagmiConfig = createConfig({
  chains: chains,
  transports: {
 [flare.id]: http()
   },
   connectors: [
      walletConnect({ projectId, metadata, showQrModal: false }),
       injected({ shimDisconnect: true }),
       coinbaseWallet({
         appName: metadata.name
       })
    ]
   })
//export const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata });
// 3. Create modal
createWeb3Modal({
  wagmiConfig,
  projectId,
  chains,
  themeMode: "light",
  themeVariables: {
    "--w3m-border-radius-master": "0.085rem",
  },
});
